export default "__VITE_ASSET__CxKFWFZy__"